import { render, staticRenderFns } from "./MarketingAuster.vue?vue&type=template&id=29930f93&scoped=true&"
import script from "./MarketingAuster.vue?vue&type=script&lang=js&"
export * from "./MarketingAuster.vue?vue&type=script&lang=js&"
import style0 from "./MarketingAuster.vue?vue&type=style&index=0&id=29930f93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29930f93",
  null
  
)

export default component.exports